import { Request } from "../base/models.jsx";
import { MetaDataBin } from "../../utils/bins/models.jsx";
import Url from "../../utils/validators/url"

const SERVICE_ID = 3;

class NoticeCategory {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};
		this.id = jsonData.id;
		this.name = jsonData.name;
		this.mainCategoryId = jsonData.mainCategoryId;
		this.activated = jsonData.activated;

		if (jsonData.mainCategory) {
			this.mainCategory = new NoticeCategory(jsonData.mainCategory);
		}

		this.subCategories = [];
		if (jsonData.subCategories) {
			for (var index = 0; index < jsonData.subCategories.length; index++) {
				this.addSubCategory(new NoticeCategory(jsonData.subCategories[index]));
			}
		}
	}

	addSubCategory(noticeCategory) {
		this.subCategories.push(noticeCategory);
	}

	copySimple(otherCategory) {
		this.id = otherCategory.id;
		this.name = otherCategory.name;
		this.mainCategoryId = otherCategory.mainCategoryId;
		this.activated = otherCategory.activated;
	}
	
}

class Notice extends Request {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined) {
			jsonData = {};
			super(jsonData);
			this.creation();
		} else {
			super(jsonData);
		}

		this.title = jsonData.title;
		this.body = jsonData.body;
		this.binId = jsonData.binId;
		this.categoryId = jsonData.categoryId;
		this.url = jsonData.url;
		this.alert = jsonData.alert;
		
		if (this.alert === undefined || this.alert == null)
			this.alert = false;

		if (jsonData.bin)
			this.bin = new MetaDataBin(jsonData.bin);
		if (jsonData.noticeCategory)
			this.noticeCategory = new NoticeCategory(jsonData.noticeCategory);

		this.attachedBin = null;
	}

	creation() {
		super.creation();
		this.serviceId = SERVICE_ID;
	}

	getCategory() {
		let text = this.noticeCategory.name;
		if (this.noticeCategory.mainCategory)
			text += " · " + this.noticeCategory.mainCategory.name;
		return text;
	}

	isValid() {
		if (!this.title || !this.title.trim())
			return false;

		if (!this.body || !this.body.trim())
			return false;

		if (!this.categoryId)
			return false;

		if (this.alert === undefined || this.alert == null)
			return false;

		if (this.url && !Url.isValid(this.url))
			return false;

		return true;
	}

}

export { Notice, NoticeCategory };
